import React from 'react';
import Checkmark from '@carvana/icons/Checkmark';

const Option = ({
  option,
  DropdownIcon,
  DropdownItem,
  template,
  id,
  index,
  isSelected,
  handleOptionSelection
}) => (
  <DropdownItem
    onClick={e => handleOptionSelection(e, index)}
    isSelected={isSelected}
    data-value={option.value}
    id={`option-${index}-${id}`}
    aria-selected={isSelected}
    role="option"
  >
    {template(option, false)}

    <DropdownIcon
      condition={isSelected}
      ifTrue={Checkmark}
    />
  </DropdownItem>
);

export default Option;
